import Renovar from '../../components/forms/renovarForm/Renovar'
import '../../index.css'

function RenovarWiew() {
  return (
    <div>
        <Renovar/>
    </div>
   
  )
}

export default RenovarWiew
